import React from "react";

import StockCategoryCard from "@/app/global/components/stock-category-card";
// import { CategoryResponse, StockCategory } from "@/app/global/components/stock-category-types";
import { cn } from "@/lib/utils";
import { ProductRoute } from "@/types/product";
import { UsStockCategory } from "@/app/interface/global";

interface StockCategoryListProps {
    categories: UsStockCategory[] /* CategoryResponse[] */;
    className?: string;
    pageRoute?: ProductRoute;
}

export default function StockCategoryList({
    categories,
    className,
    pageRoute,
}: StockCategoryListProps) {
    return (
        <div
            className={cn(
                "flex w-full flex-wrap items-start justify-center gap-6",
                className,
            )}
        >
            {categories.map((category) => (
                <StockCategoryCard key={category.index} category={category} pageRoute={pageRoute} />
            ))}
        </div>
    );
}
